<div class="main disinfection">
    <div class="main-title">
        <h1>Edit Disinfection</h1>
        <p>Edit existing Disinfection Type</p>
    </div>

    <form [formGroup]="disinfectionForm" (ngSubmit)="onSubmit()">
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <label for="programName">Program Name</label>
                    <input
                        type="text"
                        id="programName"
                        class="form-control"
                        placeholder="Enter program name"
                        formControlName="disinfectionProgramName"
                    />
                </div>
            </div>
        </div>

        <!-- Same form structure as the AddDisinfectionComponent -->
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label for="disinfectionType"
                        >Type<span class="text-danger-required">*</span></label
                    >
                    <select
                        id="type"
                        formControlName="disinfectionTypeId"
                        class="form-control"
                    >
                        <option value="" disabled selected>Select</option>
                        <option
                            *ngFor="let type of disinfectionlist"
                            [value]="type.id"
                        >
                            {{ type.name }}
                        </option>
                    </select>
                    <div
                        *ngIf="
                            disinfectionForm.get('disinfectionTypeId')
                                .invalid &&
                            disinfectionForm.get('disinfectionTypeId').touched
                        "
                        class="text-danger"
                    >
                        Please Select type.
                    </div>
                </div>
            </div>

            <div class="col-md-6 instruction-group">
                <div class="text-right">
                    <button
                        type="button"
                        class="text-right btn-action"
                        (click)="addInstruction()"
                    >
                        <span class="instruction-span"
                            ><i class="fas fa-plus"></i
                        ></span>
                        New Instruction
                    </button>
                </div>

                <div class="form-group">
                    <label
                        >Instructions<span class="text-danger-required"
                            >*</span
                        ></label
                    >
                    <div formArrayName="instructionsList">
                        <div
                            *ngFor="
                                let instruction of instructionsList.controls;
                                let i = index
                            "
                            [formGroupName]="i"
                        >
                            <input
                                type="text"
                                class="form-control"
                                formControlName="instructions"
                                placeholder="Please enter instructions"
                            />
                            <div class="remove-instruction text-right">
                                <button
                                    class="remove-ins"
                                    type="button"
                                    (click)="removeInstruction(i)"
                                    *ngIf="instructionsList.length > 1"
                                >
                                    <i class="far fa-trash-alt"></i>
                                </button>
                            </div>
                            <div
                                *ngIf="
                                    instruction.get('instructions').invalid &&
                                    instruction.get('instructions').touched
                                "
                                class="text-danger"
                            >
                                Please enter instructions.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12 text-right mt-3">
                <button
                    class="btn-action-primary mr-2"
                    type="submit"
                    [disabled]="isLoading$ | async"
                >
                    <span *ngIf="!isAuthLoading">Update</span>
                    <span *ngIf="isAuthLoading">Updating...</span>
                </button>
                <button class="close-btn-secondary" (click)="cancelEdit()">
                    Cancel Edit
                </button>
                <img
                    *ngIf="isLoading$ | async"
                    src="assets/img/loader.gif"
                    alt="Loading..."
                    class="loader-image mt-2"
                />
            </div>
        </div>
    </form>
</div>
